import { apiRequest } from '../../../api/client';
import type {
  AskQuestionResponseDto,
  CreateConversationResponseDto,
  GetConversationResponseDto,
  ListConversationsResponseDto,
} from '../types/conversation';

export function createConversation(machineId: string, title?: string) {
  return apiRequest<CreateConversationResponseDto>(`/v1/machines/${encodeURIComponent(machineId)}/conversations`, {
    method: 'POST',
    body: JSON.stringify(title ? { title } : {}),
  });
}

export function listConversations(machineId: string) {
  return apiRequest<ListConversationsResponseDto>(`/v1/machines/${encodeURIComponent(machineId)}/conversations`);
}

export function getConversation(conversationId: string, turnCursor?: string | null, turnLimit = 20) {
  const query = new URLSearchParams({ turn_limit: String(turnLimit) });
  if (turnCursor) query.set('turn_cursor', turnCursor);
  return apiRequest<GetConversationResponseDto>(`/v1/conversations/${encodeURIComponent(conversationId)}?${query.toString()}`);
}

export function askQuestion(conversationId: string, question: string, documentIds?: string[]) {
  return apiRequest<AskQuestionResponseDto>(`/v1/conversations/${encodeURIComponent(conversationId)}/messages`, {
    method: 'POST',
    body: JSON.stringify({
      question,
      ...(documentIds !== undefined ? { scope: { document_ids: documentIds } } : {}),
    }),
  });
}

export function setConversationDocumentScope(conversationId: string, documentIds: string[]) {
  return apiRequest<{ schema_version: string; conversation_id: string; machine_id: string; document_ids: string[]; request_id?: string }>(
    `/v1/conversations/${encodeURIComponent(conversationId)}/scope`,
    {
      method: 'PATCH',
      body: JSON.stringify({ document_ids: documentIds }),
    },
  );
}
